import { Component, OnInit, ViewChild } from '@angular/core';
import { ExportToCsv } from 'export-to-csv';

import { AppComponent } from '../../app.component';
import { HubService } from '../../services/hub.service';
import { ReportsComponent } from './reports.component';

@Component({
  selector: 'reports-header',
  templateUrl: './reports-header.component.html',
  styleUrls: ['./reports-header.component.css'],
  providers: [],
})

export class ReportsHeaderComponent implements OnInit {
  rowCount: string;
  @ViewChild('child', { static: true }) child: ReportsComponent;

  headerUIDList: number[] = [];
  errorMessage: string;

  constructor(
    private hubService: HubService,

  ) { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }

  }

  exportInstallationsCSV(): void {
    let tempDate = new Date().toLocaleString();
    try {
      this.hubService.postInstallationsCsv([]).subscribe(
        installationsCsv => {
          console.log(installationsCsv);
          const options = {
            filename: `GeopalInstallationReports_${tempDate}`,
            useKeysAsHeaders: true,
          };
          const csvExporter = new ExportToCsv(options);
          csvExporter.generateCsv(installationsCsv);
        },
        error => this.errorMessage = <any>error,
      );
    } catch (e) {
      console.log('exportInstallationsCSV error: ' + e);
    }
  }

  receiveCount($event: string) {
    this.rowCount = $event
  }

  receiveUIDList($event: any) {
    this.headerUIDList = $event
  }


}
